import type { MapTimelineNotifyBeat } from "./mapDefinition.ts";

/**
 * Resolves timeline notify copy from optional string bags (host/i18n) or fallback.
 * Keeps `@dawn/engine` free of i18n imports.
 */
export function resolveTimelineNotifyCopy(
  beat: MapTimelineNotifyBeat,
  strings?: Readonly<Record<string, unknown>>,
): { title: string; body: string } {
  if (beat.messageKey && strings) {
    const title = strings[`${beat.messageKey}Title`];
    const body = strings[`${beat.messageKey}Body`];
    if (typeof title === "string" && typeof body === "string") {
      return { title, body };
    }
  }

  return {
    title: beat.fallback.title,
    body: beat.fallback.body,
  };
}
